import { RedoInvoicePayment } from "@types-runway/admin";

// The fields read of the invoice GET /order/:id/invoice answers for an Order, which is null
// when no provider has it (orders-api, `BillingInvoice`).
interface AnsweredInvoice {
  id: string;
  paid: boolean;
  status: string;
  provider?: string;
}

// The payment state of an Order is that of the invoice that funds it, never the Order's own
// `paid` flag, which a replacement leaves false (REDOUI-R77, R81).
export const readInvoicePayment = (invoice: AnsweredInvoice | null): RedoInvoicePayment => {
  if (!invoice) return "failed";

  return invoice.paid ? "paid" : "unpaid";
};

// The payment vendor that holds the invoice, which says where the admin can open it (XCUT-R26).
export const readInvoiceProvider = (invoice: AnsweredInvoice | null): string | null =>
  invoice?.provider ?? null;
